import {Component, Input} from '@angular/core';
import {SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'view-image-form',
    templateUrl: './image-show-form.html',
    styleUrl: './image-show-form.scss'
})
export class ViewImageFormComponent {
    @Input() imageURL: SafeResourceUrl|undefined = undefined
    public file_name: string|undefined = undefined
}